import React from "react"
import { Navigate } from "react-router-dom"
import { Criptografia } from "../Utils/Criptografia"

type Props = {
    children: JSX.Element
}

export const PrivateRoute = ({children}: Props) => {
 
  let isLogged = false;

  if (localStorage.getItem('@ecommerce/hash') === null){
    return <Navigate to="/login"/>
  }
        
  if (localStorage.getItem('@ecommerce/hash')){  
     isLogged = true;
  }

  /*console.log('valor original ', localStorage.getItem('@ecommerce/hash'))
  const hash = Criptografia.Criptografar(localStorage.getItem('@ecommerce/hash')?.toString() || '')
  console.log('criptografia', hash)
  console.log('descriptografia', Criptografia.DesCriptografar(hash))*/

  return isLogged ? children : <Navigate to="/login"/>

}